
import { getBanner, getProduct, getShow } from '@/request/api'
import { InitData } from '@/type/home'
import { normalYear } from '@/filters/timeFormat'
import { defineComponent, reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
	setup() {
		const data = reactive(new InitData())
		const router = useRouter()

		getBannerList()
		getProductList()
		getShowList()
		function getBannerList() {
			getBanner(data.searchData).then((res: any) => {
				data.bannerList = res.data

			})
		}

		function getProductList() {
			var term = {page:1,limit:3,like:'',is_top:1}
			getProduct(term).then((res)=>{
				data.productList = res.data.data
			})
		}

		function getShowList() {
			var term = {page:1,limit:3,like:''}
			getShow().then((res)=>{
				data.showList = res.data
			})
		}
		
		function onPorudctSelect(index:number) {
			if(index != data.pIndex){
				data.pIndex = index
			}
		}
		function onProduct() {
			var id = data.productList[data.pIndex].id
			var url = '/product?id='+ id
			onRouterPush(url)
			// console.log(id)
		}
		
		function onRouterPush(url:string) {
			router.push(url)
		}
		
		function onShowSelect(index:number) {
			if(index != data.sIndex){
				data.sIndex = index
			}
		}
		return { ...toRefs(data), normalYear, onPorudctSelect, onProduct, onShowSelect,onRouterPush }
	}
})
